import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from '../data.service';
import { SolvedMeetingDto, MeetingDetailsDto } from '../shared/model';

@Injectable()
export class MeetingsService {

  constructor(private dataService: DataService) { }

  getUpcomingMeetings(userEmail: string): Observable<any> {
    return this.dataService.get('Meeting/getUpcomingMeetings', { userEmail: userEmail });
  }

  getPastMeetings(userEmail: string): Observable<any> {
    return this.dataService.get('Meeting/getPastMeetings', { userEmail: userEmail });
  }

  cancelMeeting(meetingId: number): Observable<any> {
    return this.dataService.post('Meeting/CancelMeeting', meetingId);
  }

  updateMeeting(meeting: MeetingDetailsDto): Observable<any> {
    return this.dataService.put('Meeting/UpdateMeeting', meeting);
  }

  getUserDetailsForMeeting(meetingId: number): Observable<any> {
    return this.dataService.get('User/GetUserDetailsForMeeting', { meetingId: meetingId });
  }

  getMonthsTranslations(languageId: string): Observable<any> {
    return this.dataService.get('Translations/GetMonthsTranslations', { languageId: languageId });
  }
}
